import { render } from "./logos.vue?vue&type=template&id=7c74bfa0&scoped=true"
import script from "./logos.vue?vue&type=script&lang=js"
export * from "./logos.vue?vue&type=script&lang=js"

import "./logos.vue?vue&type=style&index=0&id=7c74bfa0&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/carbon-space-admin-site-CI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c74bfa0"]])

export default __exports__